module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.section.service_center":"ศูนย์บริการ","page.section.head_office":"สำนักงาน","page.section.inactive":"ยกเลิกชั่วคราว","page.section.central":"ศูนย์บริการกลาง"}}')
  delete Component.options._Ctor
}
